import React, { useEffect, useState } from "react";
import { handleError, handleSuccess } from "../../../Utils";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Select from "react-select";
import dayjs from "dayjs";
import { companyOptions } from "../../../Data/SelectOptions";
import {
  createReferrals,
  mentorSignup,
  sendEmailOtp,
  sendNumberOtp,
  verifyEmailOtp,
  verifyNumberOtp,
} from "../../../ApiServices/ApiServices";

const MentorOnboarding = () => {
  // State variables
  const [name, setName] = useState("");
  const [dob, setDob] = useState("");
  const [gender, setGender] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [graduationPassingYear, setGraduationPassingYear] = useState(null);
  const [password, setPassword] = useState("");
  const [cpassword, setcPassword] = useState("");
  const [isAcceptedPolicy, setIsAcceptedPolicy] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();
  const [mailOtp, setMailOtp] = useState("");
  const [numOtp, setNumOtp] = useState("");
  const [isEditableNum, setIsEditableNum] = useState(true);
  const [isEditableEmail, setIsEditableEmail] = useState(true);
  const [isNumOtpInputVisible, setIsNumOtpInputVisible] = useState(false);
  const [isEmailOtpInputVisible, setIsEmailOtpInputVisible] = useState(false);
  const location = useLocation();
  const from = location.state?.from || "/dashboard";
  const referralCode = location.state?.referralCode;
  const [loading, setLoading] = useState(false);
  const [hasVerifiedMailOtp, setHasVerifiedMailOtp] = useState(false);
  const [hasVerifiedNumOtp, setHasVerifiedNumOtp] = useState(false);
  const [timerEmailOtp, setTimerEmailOtp] = useState(0);
  const [timerNumOtp, setTimerNumOtp] = useState(0);
  const [otherCompany, setOtherCompany] = useState("");

  useEffect(() => {
    document.title = "Codequeue - Mentor Onboarding";
  }, []);

  useEffect(() => {
    let interval = null;
    if (timerEmailOtp > 0) {
      interval = setInterval(() => {
        setTimerEmailOtp((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timerEmailOtp]);

  useEffect(() => {
    let interval = null;
    if (timerNumOtp > 0) {
      interval = setInterval(() => {
        setTimerNumOtp((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timerNumOtp]);

  // OTP functions
  const emailOtpSend = async () => {
    if (timerEmailOtp > 0) return; // Prevent sending again while timer is running
    try {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(email)) {
        return handleError("Please Enter Valid Email.");
      }
      const response = await sendEmailOtp(email);
      setIsEmailOtpInputVisible(true);
      setTimerEmailOtp(30);
      return handleSuccess(response.message);
    } catch (error) {
      return handleError(error?.response?.data?.message);
    }
  };

  const emailOtpVerify = async () => {
    try {
      const response = await verifyEmailOtp(email, mailOtp);
      setMailOtp("");
      setHasVerifiedMailOtp(response?.success);
      setIsEmailOtpInputVisible(false);
      setIsEditableEmail(false);
      return handleSuccess(response.message);
    } catch (error) {
      return handleError(error?.response?.data?.message);
    }
  };

  const numOtpSend = async () => {
    if (timerNumOtp > 0) return; // Prevent sending again while timer is running
    try {
      const phoneRegex = /^\d{10}$/;
      if (!phoneRegex.test(phone)) {
        return handleError("Phone number must be exactly 10 digits.");
      }
      const response = await sendNumberOtp(phone);
      setIsNumOtpInputVisible(true);
      setTimerNumOtp(30);
      return handleSuccess(response.message);
    } catch (error) {
      return handleError(error?.response?.data?.message);
    }
  };

  const numOtpVerify = async () => {
    try {
      const otp = numOtp;
      const response = await verifyNumberOtp(phone, otp);
      setHasVerifiedNumOtp(response?.success);
      setNumOtp("");
      setIsNumOtpInputVisible(false);
      setIsEditableNum(false);
      return handleSuccess(response.message);
    } catch (error) {
      return handleError(error?.response?.data?.message);
    }
  };

  const toggleBackPage = (index) => {
    if (index === 2) {
      setCurrentIndex(currentIndex - 1);
    }
    if (index === 1) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const toggleNextPage = async (index) => {
    if (index === 0) {
      if(!hasVerifiedMailOtp) return handleError("Please verify your email!");
      if(!hasVerifiedNumOtp) return handleError("Please verify your phone number!")
      setCurrentIndex(currentIndex + 1);
    }
    if (index === 1) {
      if(!name || !selectedCompany || !graduationPassingYear) return handleError("Fill required information!") 
      setCurrentIndex(currentIndex + 1);
    }
    if (index === 2 && isAcceptedPolicy) {
      try {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
          return handleError("Please enter a valid email address");
        }
        if (!/^\d{10}$/.test(phone)) {
          return handleError("Phone number must be exactly 10 digits");
        }
        if (name.length < 3) {
          return handleError("Name must be at least 3 characters long");
        }
        if (!selectedCompany) {
          return handleError("Please enter current company name");
        }
        if (!graduationPassingYear) {
          return handleError("Passing year is required");
        }
        if (password.length < 6) {
          return handleError("Password must be at least 6 characters");
        }

        if (password !== cpassword) {
          return handleError("Passwords do not match");
        }
        setLoading(true);
        const response = await mentorSignup(
          name,
          email,
          phone,
          selectedCompany.value === "Other"
            ? otherCompany
            : selectedCompany.value,
          graduationPassingYear.$y,
          password,
          isAcceptedPolicy,
          dob,
          gender
        );
        // referral process if referral code is present
        if (referralCode) {
          const referralsData = {};
          referralsData.referralCode = referralCode;
          referralsData.email = email;
          referralsData.role = "mentor";
          referralsData.name = name;
          await createReferrals(referralsData);
        } // for now we do not give any referral rewards

        handleSuccess(response.message);
        setEmail("");
        setPhone("");
        setName("");
        setSelectedCompany("");
        setGraduationPassingYear(null);
        setPassword("");
        setcPassword("");
        setIsAcceptedPolicy(false);
        navigate(from);
      } catch (error) {
        return handleError(error?.response?.data?.message);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleCheckboxChange = (e) => {
    setIsAcceptedPolicy(e.target.checked);
  };

  return (
    <div className="mentor-onboarding bg-gray-100 flex flex-col items-center pt-24 py-16">
      <div className="m-onboarding bg-white shadow-md rounded-lg w-full max-w-md p-6">
        <h3 className="mentor-header-text text-xl font-semibold text-gray-800 mb-6 text-center p-4">
          Join or Sign in as a Mentor
        </h3>
        <form className="mentor-form flex flex-col gap-4">
          {/* Step 1: Email and Phone Section */}
          {currentIndex === 0 && (
            <>
              <div className="mentor-form-group flex flex-col">
                <label
                  htmlFor="email"
                  className="text-sm font-medium text-gray-700"
                >
                  Email:
                </label>
                <div className="flex items-center ">
                  <input
                    readOnly={!isEditableEmail}
                    type="email"
                    id="email"
                    value={email}
                    placeholder="Your email address"
                    onChange={(e) =>
                      setEmail(e.target.value.trim().toLowerCase())
                    }
                    required
                    className="flex-1 h-12 border border-gray-300 rounded-md p-2 focus:outline-none focus:ring focus:ring-indigo-50"
                  />
                  <span
                    onClick={() => {
                      if (hasVerifiedMailOtp || timerEmailOtp > 0) return null;
                      emailOtpSend();
                    }}
                    className={`flex h-12 w-20 justify-center items-center rounded-tr-md rounded-br-md font-bold ${
                      hasVerifiedMailOtp
                        ? "bg-green-600 text-white cursor-not-allowed"
                        : "hover:bg-gray-500 active:bg-gray-600 bg-gray-400 text-gray-900 cursor-pointer"
                    }`}
                  >
                    {hasVerifiedMailOtp ? "Verified" : "Verify"}
                  </span>
                </div>
                {timerEmailOtp > 0 && !hasVerifiedMailOtp && (
                  <p className="text-[12px] text-yellow-600">
                    OTP resend in {timerEmailOtp}s
                  </p>
                )}
                {isEmailOtpInputVisible && (
                  <div className="otp-verify flex items-center gap-2 mt-2">
                    <input
                      type="text"
                      placeholder="Enter OTP"
                      value={mailOtp}
                      onChange={(e) => setMailOtp(e.target.value)}
                      className="flex-1  border border-gray-300 rounded-md p-2 focus:outline-none focus:ring focus:ring-indigo-50"
                    />
                    <button
                      type="button"
                      onClick={emailOtpVerify}
                      className="bg-green-600 text-white px-3 py-1 rounded-md hover:bg-indigo-700"
                    >
                      Verify
                    </button>
                  </div>
                )}
              </div>

              <div className="mentor-form-group flex flex-col">
                <label
                  htmlFor="phone"
                  className="text-sm font-medium text-gray-700"
                >
                  Phone:
                </label>
                <div className="flex items-center ">
                  <input
                    readOnly={!isEditableNum}
                    type="tel"
                    id="phone"
                    placeholder="Your phone number"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    required
                    className="flex-1 h-12 border border-gray-300 rounded-md p-2 focus:outline-none focus:ring focus:ring-indigo-50"
                  />
                  <span
                    onClick={() => {
                      if (hasVerifiedNumOtp || timerNumOtp > 0) return null;
                      numOtpSend();
                    }}
                    className={`flex h-12 w-20 justify-center items-center rounded-tr-md rounded-br-md font-bold ${
                      hasVerifiedNumOtp
                        ? "bg-green-600 text-white cursor-not-allowed"
                        : "hover:bg-gray-500 active:bg-gray-600 bg-gray-400 text-gray-900 cursor-pointer"
                    }`}
                  >
                    {hasVerifiedNumOtp ? "Verified" : "Verify"}
                  </span>
                </div>
                {timerNumOtp > 0 && !hasVerifiedNumOtp && (
                  <p className="text-[12px] text-yellow-600">
                    OTP resend in {timerNumOtp}s
                  </p>
                )}
                {isNumOtpInputVisible && (
                  <div className="otp-verify flex items-center gap-2 mt-2">
                    <input
                      type="text"
                      placeholder="Enter OTP"
                      value={numOtp}
                      onChange={(e) => setNumOtp(e.target.value)}
                      className="flex-1 border border-gray-300 rounded-md p-2 focus:outline-none focus:ring focus:ring-indigo-50"
                    />
                    <button
                      type="button"
                      onClick={numOtpVerify}
                      className="bg-green-600 text-white px-3 py-1 rounded-md hover:bg-indigo-700"
                    >
                      Verify
                    </button>
                  </div>
                )}
              </div>
            </>
          )}

          {/* Step 2: Name, Current Company, Graduation Year */}
          {currentIndex === 1 && (
            <>
              <div className="mentor-form-group flex flex-col">
                <label
                  htmlFor="name"
                  className="text-sm font-medium text-gray-700"
                >
                  Name:
                </label>
                <input
                  type="text"
                  id="name"
                  value={name}
                  placeholder="Your Name"
                  onChange={(e) => setName(e.target.value)}
                  required
                  className="border border-gray-300 rounded-md p-2 focus:outline-none focus:ring focus:ring-indigo-50"
                />
              </div>

              <div className="mentor-form-group flex flex-col">
                <label
                  htmlFor="dob"
                  className="text-sm font-medium text-gray-700"
                >
                  Date of Birth:
                </label>
                <input
                  type="date"
                  id="dob"
                  value={dob}
                  onChange={(e) => setDob(e.target.value)}
                  required
                  className="border border-gray-300 rounded-md p-2 focus:outline-none focus:ring focus:ring-indigo-50"
                />
              </div>

              <div className="mentor-form-group flex flex-col">
                <label
                  htmlFor="gender"
                  className="text-sm font-medium text-gray-700"
                >
                  Gender:
                </label>
                <select
                  id="gender"
                  value={gender}
                  onChange={(e) => setGender(e.target.value)}
                  required
                  className="border border-gray-300 rounded-md p-2 focus:outline-none focus:ring focus:ring-indigo-50"
                >
                  <option value="">Select Gender</option>
                  <option value="female">Female</option>
                  <option value="male">Male</option>
                  <option value="other">Other</option>
                  <option value="prefer_not_to_say">Prefer not to say</option>
                </select>
              </div>

              <div className="mentor-form-group flex flex-col">
                <label
                  htmlFor="currentCompany"
                  className="text-sm font-medium text-gray-700"
                >
                  Current Company:
                </label>
                <Select
                  options={companyOptions}
                  isSearchable
                  isClearable
                  className="current-company-options"
                  value={selectedCompany}
                  onChange={(selectedOption) =>
                    setSelectedCompany(selectedOption)
                  }
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      boxShadow: "none",
                    }),
                  }}
                  menuPlacement="auto"
                  menuPosition="fixed"
                />
                {selectedCompany?.value === "Other" && (
                  <input
                    type="text"
                    id="company"
                    value={otherCompany}
                    placeholder="Other Company"
                    onChange={(e) => setOtherCompany(e.target.value)}
                    required
                    className="border border-gray-300 rounded-md p-2 mt-2 focus:outline-none focus:ring focus:ring-indigo-50"
                  />
                )}
              </div>

              <div className="mentor-form-group flex flex-col">
                <label
                  htmlFor="graduationYear"
                  className="text-sm font-medium text-gray-700"
                >
                  Graduation (passing year):
                </label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    className="border border-gray-300 rounded-md "
                    value={graduationPassingYear}
                    onChange={(date) => setGraduationPassingYear(date)}
                    format="YYYY"
                    views={["year"]}
                    minDate={dayjs("1900-01-01")}
                    maxDate={dayjs().endOf("year")}
                  />
                </LocalizationProvider>
              </div>
            </>
          )}

          {/* Step 3: Password Section */}
          {currentIndex === 2 && (
            <>
              <div className="mentor-form-group flex flex-col">
                <label
                  htmlFor="password"
                  className="text-sm font-medium text-gray-700"
                >
                  Password:
                </label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  placeholder="Password"
                  onChange={(e) => setPassword(e.target.value.trim())}
                  required
                  className="border border-gray-300 rounded-md p-2 focus:outline-none focus:ring focus:ring-indigo-50"
                />
              </div>

              <div className="mentor-form-group flex flex-col">
                <label
                  htmlFor="cpassword"
                  className="text-sm font-medium text-gray-700"
                >
                  Confirm Password:
                </label>
                <input
                  type="password"
                  id="cpassword"
                  value={cpassword}
                  placeholder="Confirm Password"
                  onChange={(e) => setcPassword(e.target.value.trim())}
                  required
                  className="border border-gray-300 rounded-md p-2 focus:outline-none focus:ring focus:ring-indigo-50"
                />
              </div>

              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  id="terms"
                  required
                  className="check-box h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                  checked={isAcceptedPolicy}
                  onChange={handleCheckboxChange}
                />
                <label
                  htmlFor="terms"
                  className="text-sm font-medium text-gray-700"
                >
                  I agree to the{" "}
                  <a
                    href="/terms-and-conditions"
                    target="_blank"
                    className="text-indigo-600 hover:underline"
                  >
                    {/* T&C */}
                  </a>
                  {/* and */}
                  <NavLink
                    to="/privacy-and-policy"
                    target="_blank"
                    className="text-indigo-600 hover:underline"
                  >
                    Privacy & Policy
                  </NavLink>
                </label>
              </div>
            </>
          )}

          {/* Navigation Buttons */}
          <div className="flex  justify-between items-center mt-4 gap-4">
            {/* {currentIndex > 0 && ( */}
            <button
              type="button"
              className={`secondary-btn text-sm text-gray-600 ${
                currentIndex > 0 ? "" : "invisible"
              }`}
              onClick={() => toggleBackPage(currentIndex)}
            >
              Back
            </button>

            <div className="text-end">
              <button
                type="button"
                className={`primary-btn text-sm bg-indigo-600 text-white py-2 px-4 rounded ${
                  currentIndex === 2 && !isAcceptedPolicy
                    ? "opacity-50 cursor-not-allowed"
                    : ""
                }`}
                onClick={() => toggleNextPage(currentIndex)}
              >
                {currentIndex === 2 ? (
                  loading ? (
                    <div className="spinner" />
                  ) : (
                    "Submit"
                  )
                ) : (
                  "Next"
                )}
              </button>
            </div>
          </div>
        </form>
        <div className="text-center">
          <div
            className="w-full text-center mt-4"
          >
            Join as a Mentee <NavLink to={"/signup"} className="underline text-blue-700">Click here</NavLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MentorOnboarding;
